<form class="flex flex-col gap-6" (submit)="submit($event)">
  <p class="m-0 inline-flex w-fit items-center gap-2 rounded-full bg-primary/10 py-1.5 pr-3.5 pl-1.5 text-sm font-bold text-accent">
    <span class="flex size-7 items-center justify-center rounded-md bg-linear-to-br from-brand-studio-dark to-brand-studio text-xs font-black text-white" aria-hidden="true">{{ initial() }}</span>
    {{ onboarding.brandName() }} workspace reserved
  </p>

  <div class="flex flex-col gap-3">
    <h1 class="use-grotesque m-0 text-4xl font-bold leading-none tracking-tight text-balance sm:text-5xl">Save your workspace</h1>
    <p class="m-0 text-xl font-semibold leading-snug text-muted-foreground">
      We'll email you a 6-digit code to claim {{ onboarding.brandName() }} on SHOUT. {{ priceLine() }}
    </p>
  </div>

  <button type="button" class="btn-shout btn-shout-md btn-shout-secondary w-full justify-center" [disabled]="onboarding.registering()" (click)="google()">
    
    <span>
      <img src="../../../../../assets/google-sign-in/google-icon-logo.svg" alt="Google" class="size-4" />
    </span>

    Continue with Google

    @if (onboarding.registering()) {
      <span class="size-4 animate-spin rounded-full border-2 border-border border-t-primary" aria-hidden="true"></span>
    }
  </button>

  <div class="flex items-center gap-3" aria-hidden="true">
    <div class="h-px flex-1 bg-border"></div>
    <p class="m-0 text-sm font-bold text-muted-foreground">OR</p>
    <div class="h-px flex-1 bg-border"></div>
  </div>

  <div class="flex flex-col gap-2">
    <label for="vf-email" class="text-base font-bold">Work email</label>
    <input
      id="vf-email"
      type="email"
      autocomplete="email"
      placeholder="you@company.com"
      class="h-14 rounded-lg border border-border bg-card px-4 text-lg text-foreground outline-none placeholder:text-muted-foreground focus:border-primary focus:ring-2 focus:ring-primary/20"
      [class.border-red-600]="onboarding.error()"
      [value]="onboarding.draft().email"
      (input)="onEmail($event)" />
    @if (onboarding.error()) {
      <p class="m-0 text-base font-semibold text-red-600 dark:text-red-400" role="alert">{{ onboarding.error() }}</p>
    }
  </div>

  <input #honeypotInput type="text" tabindex="-1" autocomplete="off" class="hidden" aria-hidden="true" />
  <div #turnstileContainer></div>

  <p class="m-0 text-base font-semibold text-muted-foreground">Trusted by teams at Adobe, BYD, GOLIN, Pizza Hut and monday.com</p>

  <div class="fixed inset-x-0 bottom-0 z-20 border-t border-border bg-background px-5 py-3 sm:static sm:z-auto sm:border-0 sm:bg-transparent sm:p-0">
    <button type="submit" class="btn-shout btn-shout-md btn-shout-primary w-full justify-center" [disabled]="onboarding.sendingCode()">
      @if (onboarding.sendingCode()) {
        <span class="size-4 animate-spin rounded-full border-2 border-white/40 border-t-white" aria-hidden="true"></span>
        Sending code…
      } @else {
        Send code →
      }
    </button>
    <p class="m-0 mt-2 text-center text-sm font-semibold text-muted-foreground">
      Protected by Cloudflare Turnstile. By continuing you agree to our
      <a href="https://www.shout.com/terms" class="font-bold text-primary" target="_blank" rel="noopener noreferrer">Terms</a>
      and
      <a href="https://www.shout.com/privacy" class="font-bold text-primary" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
    </p>
  </div>
</form>
